import { css } from 'lit'

// these styles can be imported from any component
// for an example of how to use this, check /pages/about-about.ts
export const styles = css`
   :host {
      width: 100%;
      margin: 0 auto;
      padding: 34px 0;
      position: relative;
      display: block;
      box-sizing: border-box;
      font-family: Roboto, Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
      line-height: 1.5;
      font-weight: 400;
      font-synthesis: none;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    .cta-container {
      display: flex;
      gap: 15px;
    }

    sl-button.cta {
      flex: 1;
      min-width: 0;
    }

    sp-icon-info {
     color: #5483d0;
    }

    .hidden {
      display: none;
    }

    .error {
      color: #b3261e;
      font-weight: 600;
      text-align: center;
    }

    sl-card {
      text-align: center;
      width: 100%;
      margin-bottom: 30px;
    }

    section.emphasized {
      background-color: #fff;
    text-align: center;
    padding: 30px;
    border-radius: 18px;
    margin-bottom: 20px;
    filter: drop-shadow(.5px 1px 1px hsla(0, 0%, 54%, 0.15)) drop-shadow(1px 2px 2px hsl(285deg 40% 40%/.15)) drop-shadow(2px 4px 4px hsla(270, 1%, 49%, 0.15)) drop-shadow(4px 8px 8px hsla(270, 1%, 50%, 0.15)) ;
    }

    section.emphasized.header {    
      padding: 30px 0;
      width: 100%;
      margin-bottom: 30px;
    }


    dl {
      margin-top: 0;
    }

    dl dd {
      margin-left: 0;
    }

    section {
      min-width: min-content;
      margin: 25px auto 50px auto;
    }
    section.holiday time-range {
      max-width: max-content;
    margin: 0 auto;
    }

    section p {
      text-shadow: 0ex 0ex 3px #fff;
    }

    section.view ul li span:first-child {
        padding-right: 10px;
    }

    section + section {
      margin-top: 15px;
    }

    form {
      margin-bottom: 35px;
    }

    form time-range {
      margin-bottom: 0;
    }

    form time-range[off][switch] + time-range {
      display: none;
    }

    form time-range[switch] + time-range{
      margin-bottom: 15px;
    }

    
    a {
      font-weight: 500;
      color: #609BE2;
      text-decoration: inherit;
      font-size: 30px;
      float: left;
      font-weight: 500;
    position: absolute;
    top: 55px;
    padding-left: 10px;
    text-decoration: inherit;
    }
    a:hover {
      color: #535bf2;
    }

    input {
      font-family: Roboto;
      color: #333;
    }

    li {
      list-style-type: none;
      margin-left: 0;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    ul.regular li span:first-child {
      display: inline-block;
      width: 80px;
    }
    h1, h2, h3, h4, h5 {
      margin-top: 0;
      text-align: center;
      font-family: 'Asap Condensed';
    }
    ul {
      padding: 0;
      margin-bottom: 30px;
    }
/* --spectrum-switch-control-label-spacing: 5px; */

    section.view ul li span.bind {
      padding: 2px 14px;
    }
/*
    input[type="time"]::-webkit-calendar-picker-indicator{
      filter: invert(0%) sepia(0%) saturate(3205%) hue-rotate(130deg) brightness(9.7%) contrast(90.96%);
    }
      */

    @media (max-width: 450px) {
      
    }

    @media (max-width: 385px) {
      
    }
`
